import { render } from "./EditEmployeeReport.vue?vue&type=template&id=77eb50cc&scoped=true"
import script from "./EditEmployeeReport.vue?vue&type=script&lang=js"
export * from "./EditEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=77eb50cc&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77eb50cc"]])

export default __exports__